import { React } from 'react';
import TeamCard from './TeamCard';

const teams = [
    {
        teamName: "PCA Team",
        teamEmail: "list-pcateam@csgi.com"
    },
    {
        teamName: "OE Team",
        teamEmail: "list-oeteam@csgi.com"
    },
    {
        teamName: "FinOps Team",
        teamEmail: "list-finopsteam@csgi.com"
    }
];

const Teams = () => {
    return (
        <>
            <h2 className="text-center mb-4">Contact the teams directly</h2>
            <div className="row">
                <div className="col-md-8 mx-auto">
                    <div className="row">
                        {teams.map((team, index) => (
                            <TeamCard
                                key={index}
                                teamName={team.teamName}
                                teamEmail={team.teamEmail}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Teams;
